<template>
  <div class="content">
    <div class="row">
      <div class="col-12 col-md-8 ">
        <h3 class="mb-1">Consulter l'historique de vos notes</h3>
        <p class="" v-if="conf.isPro">
          Les 100 dernières notes enregistrées sont consultables ici, toutes
          valeurs confondues.
        </p>
        <p class="" v-if="!conf.isPro">
          <i
            class="tim-icons icon-alert-circle-exc text-primary mr-2"
            aria-hidden="true"
          ></i>
          Vous pouvez consulter les notes à partir de votre dashboard ou des
          screeners.<br />
          <router-link class="pointer text-primary ml-4" tag="b" to="/pro">
            <b>Passer pro</b>
          </router-link>
          pour consulter vos 100 dernières notes sur cet écran.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div>
            <base-table :data="notes" thead-classes="text-primary">
              <template slot="columns">
                <th style="width: 200px" class="text-left">Instrument</th>
                <th style="width: 200px">Date</th>
                <th class="text-left">Note</th>
                <th class="text-center">Action</th>
                <th></th>
              </template>
              <template slot-scope="{ row }">
                <td>
                  {{ row.info.na }}<br />
                  <market :name="row.info.mk"></market>
                  <small title="Symbole">{{ row.info.sy }}</small>
                </td>
                <td>
                  <h5 class="">
                    {{ $moment(row.data.t * 1000).format("lll") }}
                  </h5>
                </td>
                <td>
                  <pre class="">{{ row.data.content }}</pre>
                </td>
                <td class="text-center" style="width: 80px">
                  <i
                    class="text-warning pointer tim-icons icon-trash-simple"
                    @click="removeNoteClick(row)"
                  ></i>
                </td>
              </template>
            </base-table>
            <div class="text-center" v-if="conf.isPro && notes.length === 0">
              <b class="text-primary">Il ne se passe pas grand chose ici :) </b>
              <br />
              Vous pouvez ajouter des notes à tout moment depuis le dashboard,
              les screeners ou le détail d'une valeur.
            </div>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          ></div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { BaseTable, Market } from "@/components";
import { deleteNote, searchNotes } from "../../dao/firestore";

export default {
  components: {
    BaseTable,
    Market
  },
  computed: {
    ...mapGetters({
      livelist: "instruments/livelist",
      conf: "auth/conf",
      user: "auth/user",
      mode: "auth/mode"
    }),
    cur() {
      return this.mode === "pea" ? "€" : "$";
    }
  },
  data() {
    return {
      notes: []
    };
  },
  methods: {
    async loadNotes() {
      if (!this.livelist.length || !this.conf.isPro) return;

      const result = await searchNotes(this.user, null, this.mode, 100);

      this.notes = this.$store.getters["instruments/addInfoToList"](
        result.map(n => ({ ...n, isin: n.data.isin }))
      ).filter(p => !!p.info);
    },
    async removeNoteClick(note) {
      await deleteNote(note.uid);
      await this.loadNotes();
    }
  },
  async mounted() {
    await this.loadNotes();
  },
  watch: {},
  metaInfo() {
    return {
      title: "Notes"
    };
  }
};
</script>
<style></style>
